export const activeModules = ["banks", "projects", "purchasing","cashflow"];
export const purDECIMALS = 4;
export const purTOLERANCE = 0.001;
